import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, ModalController, ToastController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { SetdrivershiftPage } from '../setdrivershift/setdrivershift';

/**
 * Generated class for the PopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup',
  templateUrl: 'popup.html',
})
export class PopupPage {
  PopupType = ''
  PopupType2 = ''
  PopupSelected: any
  PopupSelectedText: string = ''
  PopupArray: any
  popData = []
  generalIcon = ''
  sliderValue = 1
  OnlyOneVehicle = false
  InChooseVehicle = false
  countVisible = 0;
  GroupElements = 0;
  rvInterval: any = null
  moreThanOneVeh: any;
  alldrivers: any
  allassets: any

  schedidVeh: any

  nekoja: any

  vehiclepulses: any
  vehicletank: any
  vehicledigalkaanalogna: any
  rec: any
  tachogram: any
  beacon: any
  agrtf: any
  indoorbeacon: any
  fuel: any
  cbfuel: any
  speedlimitbuzzer: any
  draegerdata: any
  securitystatereport: any
  baddrivingvehilces: any

  firstvehdragfalse: any
  idfirstvehdragfalse = []
  techmalfunction: any
  vehInRoute = false;
  vehOutRoute = false;
  bluetoothtemp: any
  trafficrules: any
  allbk = []
  selectedModal: any;
  cntSelected = 0;
  isforzero = false

  nowHH = ''
  todayTraj = true
  electricveh: any

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public viewCtrl: ViewController, public alertCtrl: AlertController, public modalCtrl: ModalController, public toastCtrl: ToastController) {
    this.PopupType = navParams.get('type')
    this.allbk = navParams.get('allbk')
    this.PopupSelected = navParams.get('selected')
    this.PopupArray = navParams.get('arrayData')
    this.nowHH = parseInt(moment().format("HH")) + ''
    this.sliderValue = parseInt(this.nowHH)

    this.firstvehdragfalse = navParams.get('firstvehdragfalse')
    // console.log(this.firstvehdragfalse, 'this.firstvehdragfalse')
    if (navParams.get('onlyonevehicle') != null) {
      this.OnlyOneVehicle = navParams.get('onlyonevehicle')
    }
    if (navParams.get('vehInRoute') != null) {
      this.vehInRoute = navParams.get('vehInRoute')
    }
    if (navParams.get('vehOutRoute') != null) {
      this.vehOutRoute = navParams.get('vehOutRoute')
    }

    this.moreThanOneVeh = navParams.get('_if')
    this.alldrivers = navParams.get('clientDrivers')
    this.allassets = navParams.get('clientAssets')
    this.vehiclepulses = navParams.get('allowpulses')
    this.vehicletank = navParams.get('allowtank')
    this.vehicledigalkaanalogna = navParams.get('allowdigalkaanalogna')
    this.rec = navParams.get('rec')
    this.tachogram = navParams.get('allowtachogram')
    this.beacon = navParams.get('allowbeacon')
    this.agrtf = navParams.get('agrtf')
    this.indoorbeacon = navParams.get('allowindoorbeacon')
    this.fuel = navParams.get('allowfuel')
    this.cbfuel = navParams.get('allowcbfuel')
    this.speedlimitbuzzer = navParams.get('speedlimitbuzzer')
    this.draegerdata = navParams.get('draegerdata')
    this.securitystatereport = navParams.get('securityreport')
    this.baddrivingvehilces = navParams.get('baddrivingvehicle')
    this.trafficrules = navParams.get('trafficruless')
    this.techmalfunction = navParams.get('techmalfunc')
    this.bluetoothtemp = navParams.get('bletemp')
    this.electricveh = navParams.get('electric')
    //console.log(this.electricveh, 'this.electricveh')
    // console.log(this.alldrivers, 'daj da vidam all drivers')
    // console.log(this.PopupSelected, 'popupselected')
  }

  showVehiclesRoute(tf: any, _ch) {
    // if(tf == 0) this.vehOutRoute = _ch
    // if(tf == 1) this.vehInRoute = _ch
    var tmp = false;
    if (_ch) {
      if ((tf == 0 && this.vehInRoute) || (tf == 1 && this.vehOutRoute)) {
        tmp = true;
      }
      if (tmp) {
        this.popData[0].data[0].checked = true;
        for (var i = 1; i < this.popData.length; i++) {
          this.popData[i].checked = true;
          for (var j = 0; j < this.popData[i].data.length; j++) {
            this.popData[i].data[j].checked = true;
          }
        }
      }
    }

    if (!tmp) {
      //nadvor od ruta
      // if (tf == 0) {
      //   this.popData[0].data[0].checked = false;
      //   var _that = this;
      //   setTimeout(function () {
      //     for (var i = 1; i < _that.popData.length; i++) {
      //       for (var j = 0; j < _that.popData[i].data.length; j++) {
      //         if (!_that.vehInRoute)
      //           _that.popData[i].data[j].checked = false;
      //         else {
      //           if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.popData[i].data[j].id]].routedetails + '' != '-1') {
      //             _that.popData[i].data[j].checked = true;
      //           }
      //         }

      //         if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.popData[i].data[j].id]].routedetails + '' == '-1') {
      //           _that.popData[i].data[j].checked = _ch;
      //         }
      //       }
      //     }
      //   }, 50);
      // }
      //vo ruta
      if (tf == 1) {
        this.popData[0].data[0].checked = false;
        var _that = this;
        setTimeout(function () {
          for (var i = 1; i < _that.popData.length; i++) {
            for (var j = 0; j < _that.popData[i].data.length; j++) {
              if (!_that.vehOutRoute)
                _that.popData[i].data[j].checked = false;
              else {
                if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.popData[i].data[j].id]].routedetails + '' == '-1') {
                  _that.popData[i].data[j].checked = true;
                }
              }

              if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.popData[i].data[j].id]].routedetails + '' != '-1') {
                _that.popData[i].data[j].checked = _ch;
              }
            }
          }
        }, 20);
      }
    }
  }

  setVisibleGrup(_group) {
    if (_group.data.show != true) {
      _group.data.show = true;
    } else {
      _group.data.show = false;
    }
  }
  chooseVehiclesGroup(o: any, ev: any, index: any) {



    // if (index != 0) {
    var _ch = ev.value;
    for (let i = 0; i < o.data.length; i++) {
      o.data[i].checked = _ch;
      o.data[i].visible
    }
    // }

    if (this.popData[0].data[0].checked == false) {
      if (ev.value == true) {
        for (let i = 0; i < this.popData[index].data.length; i++) {
          if (this.popData[index].data[i].approve < 2 && this.popData[index].data[i].visible_veh == false && this.popData[index].data[i].suspend == false) {
          } else {
            this.popData[1].data.push(this.popData[index].data[i])
          }
        }
        this.popData[index].data = []
      }

      if (ev.value == false && index == 1) {
        for (let i = 0; i < this.popData[index].data.length; i++) {
          for (let c = 0; c < this.popData.length; c++) {
            if (this.popData[index].data[i].org == this.popData[c].id) {
              if (this.popData[index].data[i].approve < 2 && this.popData[index].data[i].visible_veh == false && this.popData[index].data[i].suspend == false) {
              } else {
                this.popData[c].data.push(this.popData[index].data[i])
              }
            }
            this.popData[c].checked = false

          }

        }
        this.popData[index].data = []
      }
    }

    if (ev.value == true && index != 0) {
      this.popData[1].checked = true
    }

    if (index == 0) {
      this.popData[1].data = []
    }
  }





  // for (let kk = 0; kk < this.popData.length; kk++) {
  //   if (this.popData[kk].id == this.popData[_idx].data[_idx2].org) {
  //     this.popData[kk].data.push(tmp)
  //     debugger
  //     if (this.popData[kk].data == true) {
  //       this.popData[kk].checked = false
  //     }
  //     break
  //   }
  // }
  chooseVehiclesFollowGroup(o: any, ev: any) {
    var _ch = ev.value;
    for (let i = 0; i < o.data.length; i++) {
      o.data[i].checked = _ch;
      o.data[i].visible
    }
  }

  selComp(d) {
    var cb = this.navParams.get("callback")
    if (cb != null) {
      cb(d, this.popData)
    }
  }
  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }    

    // if (this.gn._latcyr(this.popData[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].name.toLowerCase()).indexOf(val) > -1) {

    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.popData.length; i++) {
      if (val == '' || val == undefined) {
        this.popData[i].visible = true

      } else {
        if (this.gn._latcyr(this.popData[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].name.toLowerCase()).indexOf(val) > -1) {
          this.popData[i].visible = true;
        }
        else {
          this.popData[i].visible = false;
        }
      }

    }
  }

  viewSearchOthers() {
    for (var i = 0; i < this.popData.length; i++) {
      this.popData[i].visible = true
    }
  }

  viewSearchOthers1() {
    for (var i = 0; i < this.popData.length; i++) {
      this.popData[i].visible = false
    }
  }


  getItemsOthers(ev: any) {
    // for (var i = 0; i < this.popData.length; i++) {
    //   this.popData[i].visible = true
    // }

    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.popData.length; i++) {
      if (val == '' || val == undefined) {

        this.popData[i].visible = true;
      }
      else {
        if (this.popData[i].name + '' == 'null' || this.popData[i].name == null) { this.popData[i].name = '' }
        if (this.gn._latcyr(this.popData[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].name.toLowerCase()).indexOf(val) > -1) {
          this.popData[i].visible = true;
        }
        else {
          this.popData[i].visible = false;

        }
      }
    }
  }

  getItemsVehCost(ev: any) {
    // for (var i = 0; i < this.popData.length; i++) {
    //   this.popData[i].visible = true
    // }
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.popData.length; i++) {
      if (val == '' || val == undefined) {

        this.popData[i].visible = true;
      }
      else {
        if (this.popData[i].name + '' == 'null' || this.popData[i].name == null) { this.popData[i].name = '' }
        if (this.gn._latcyr(this.popData[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].name.toLowerCase()).indexOf(val) > -1) {
          this.popData[i].visible = true;
        } else {
          if (this.popData[i].alias + '' == 'null' || this.popData[i].alias == null) { this.popData[i].alias = '' }
          if (this.gn._latcyr(this.popData[i].alias.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].alias.toLowerCase()).indexOf(val) > -1) {

          }
          else {
            if (this.popData[i].model + '' == 'null' || this.popData[i].model == null) { this.popData[i].model = '' }
            if (this.gn._latcyr(this.popData[i].model.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].model.toLowerCase()).indexOf(val) > -1) {

            }
            else {
              this.popData[i].visible = false;
            }

          }

        }
      }
    }
  }

  //mebelvi salon
  getItemsArticlesSalon(ev: any) {
    // for (var i = 0; i < this.popData.length; i++) {
    //   this.popData[i].visible = true
    // }
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }
    if (val == '' || val == undefined) {//|| val.length < -1) {
      //if (val == '' || val == undefined || val.length < 3) {
      for (var i = 0; i < this.popData.length; i++) {
        this.popData[i].visible = true;//false;
      }
    }
    //if (val.length >= 3) {
    if (val.length >= 0) {
      for (var i = 0; i < this.popData.length; i++) {
        if (this.popData[i].acName + '' == 'null' || this.popData[i].acName == null) { this.popData[i].acName = '' }
        if (this.gn._latcyr(this.popData[i].acName.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].acName.toLowerCase()).indexOf(val) > -1 || ((this.popData[i].acIdent) + '').indexOf(val) > -1) {
          this.popData[i].visible = true;
        } else {
          this.popData[i].visible = false;
        }
      }
    }
  }

  getItemsArticles(ev: any) {
    // for (var i = 0; i < this.popData.length; i++) {
    //   this.popData[i].visible = true
    // }
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }
    if (val == '' || val == undefined || val.length < 3) {
      for (var i = 0; i < this.popData.length; i++) {
        this.popData[i].visible = false;
      }
    }
    if (val.length >= 3) {
      for (var i = 0; i < this.popData.length; i++) {
        if (this.popData[i].name + '' == 'null' || this.popData[i].name == null) { this.popData[i].name = '' }
        if (this.gn._latcyr(this.popData[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].name.toLowerCase()).indexOf(val) > -1) {
          this.popData[i].visible = true;
        } else {
          this.popData[i].visible = false;
        }
      }
    }
  }

  getItemsVeh(ev: any) {
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.popData.length; i++) {
      var countshowvehicles = 0;
      for (let j = 0; j < this.popData[i].data.length; j++) {

        if (val == '' || val == undefined) {

          this.popData[i].data[j].visible = true
          this.popData[i].visible = true;


        } else {
          if (this.popData[i].data[j].title + '' == 'null' || this.popData[i].data[j].title == null) { this.popData[i].data[j].title = '' }
          if (this.gn._latcyr(this.popData[i].data[j].title.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].data[j].title.toLowerCase()).indexOf(val) > -1) {
            this.popData[i].data[j].visible = true
            this.popData[i].visible = true;
          }
          else {
            if (this.popData[i].data[j].alias + '' == 'null' || this.popData[i].data[j].alias == null) { this.popData[i].data[j].alias = '' }
            if (this.gn._latcyr(this.popData[i].data[j].alias.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].data[j].alias.toLowerCase()).indexOf(val) > -1) {
              this.popData[i].data[j].visible = true
              this.popData[i].visible = true;
            }
            else {
              if (this.popData[i].data[j].model + '' == 'null' || this.popData[i].data[j].model == null) { this.popData[i].data[j].model = '' }
              if (this.gn._latcyr(this.popData[i].data[j].model.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].data[j].model.toLowerCase()).indexOf(val) > -1) {
                this.popData[i].data[j].visible = true
                this.popData[i].visible = true;
              }

              else {
                if (this.popData[i].data[j].orgname + '' == 'null' || this.popData[i].data[j].orgname == null) { this.popData[i].data[j].orgname = '' }
                if (this.gn._latcyr(this.popData[i].data[j].orgname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.popData[i].data[j].orgname.toLowerCase()).indexOf(val) > -1) {
                  this.popData[i].data[j].visible = true
                  this.popData[i].visible = true;
                }
                else {
                  this.popData[i].data[j].visible = false
                  this.popData[i].visible = false;
                  this.countVisible++;
                  countshowvehicles++;
                }
              }
            }
          }
          this.popData[i].cntchecked = countshowvehicles
        }
      }
    }
  }


  fillRV() {
    this.popData = []
    for (var i = 0; i < this.gn.ReleaseVersion.length; i++) {
      var txtarr = []
      var txt = ''
      if (this.dic.Lang == 'mk') {
        txt = this.gn.ReleaseVersion[i].mktext
      } else {
        if (this.dic.Lang == 'en') {
          txt = this.gn.ReleaseVersion[i].entext
        } else {
          if (this.dic.Lang == 'fr') {
            txt = this.gn.ReleaseVersion[i].frtext
          } else {
            if (this.dic.Lang == 'sq') {
              txt = this.gn.ReleaseVersion[i].altext
            } else {
              if (this.dic.Lang == 'srb') {
                txt = this.gn.ReleaseVersion[i].srbtext
              }
            }
          }
        }
      }
      for (var j = 0; j < txt.split('; ').length; j++) {
        txtarr.push(txt.split('; ')[j])
      }
      this.popData.push({ id: this.gn.ReleaseVersion[i].id, version: this.gn.ReleaseVersion[i].version, rv: this.gn.ReleaseVersion[i].releaseversion, dt: this.gn.ReleaseVersion[i].datetime, txt: txt, txtarr: txtarr })
      //debugger
    }
  }



  ionViewWillLoad() {
    // console.log('ionViewDidLoad PopupPage');
    var _that = this

    //mebelvi salon
    if (this.PopupType == 'PrimaryClassification') {
      this.PopupType2 = 'PrimaryClassificationOther'
      this.generalIcon = 'ios-options-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name })
      }
      this.viewSearchOthers()
    }

    if (this.PopupType == 'Аrticles') {
      this.PopupType2 = 'articles-salon'
      this.generalIcon = 'ios-cube-outline'

      //this.popData.push({ id: -1, name: '--- Изберете артикл ---', articleidbyapi: -1 })
      var _that = this
      this.gn._Post('/api/getmebelviallarticles', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
        _that.popData = _data
      })

      // for (var i = 0; i < this.gn.Articles.length; i++) {
      //   this.popData.push({ id: this.gn.Articles[i].id, name: this.gn.Articles[i].name, articleidbyapi: this.gn.Articles[i].articleidbyapi })
      // }
      this.viewSearchOthers1()
    }
    var classid = this.navParams.get("class")
    if (this.PopupType == 'АrticlesByClass') {
      this.PopupType2 = 'articles-salon'
      this.generalIcon = 'ios-cube-outline'

      //this.popData.push({ id: -1, name: '--- Изберете артикл ---', articleidbyapi: -1 })
      var _that = this
      this.gn._Post('/api/getmebelviarticlesbyclass', { class: _that.gn.crypt(classid), cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
        _that.popData = _data
      })

      // for (var i = 0; i < this.gn.Articles.length; i++) {
      //   this.popData.push({ id: this.gn.Articles[i].id, name: this.gn.Articles[i].name, articleidbyapi: this.gn.Articles[i].articleidbyapi })
      // }
      this.viewSearchOthers1()
    }
    //mebelvi salon end

    var selCompId = this.navParams.get("selCompId")
    if (this.PopupType == 'components') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        for (var j = 0; j < selCompId.length; j++) {
          if (selCompId[j] + '' == this.PopupArray[i].id + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].componentname, ch: ch, visible: true })
      }
    }

    if (this.PopupType == 'components2') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        //debugger
        for (var j = 0; j < selCompId.length; j++) {
          if (selCompId[j] + '' == this.PopupArray[i].id + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, ch: ch, visible: true })
      }
    }
    var selProcId = this.navParams.get("selProcId")
    if (this.PopupType == 'processes') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        for (var j = 0; j < selProcId.length; j++) {
          if (selProcId[j] + '' == this.PopupArray[i].id + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, ch: ch, visible: true })
      }
    }

    var selCartsId = this.navParams.get("selCartsId")
    if (this.PopupType == 'routing-carts') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        for (var j = 0; j < selCartsId.length; j++) {
          if (selCartsId[j] + '' == this.PopupArray[i].id + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, ch: ch, visible: true })
      }
    }

    var selControllersId = this.navParams.get("selControllersId")
    if (this.PopupType == 'indoor-controllers') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        for (var j = 0; j < selControllersId.length; j++) {
          if (selControllersId[j] + '' == this.PopupArray[i].vehicleid + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].vehicleid, name: this.PopupArray[i].registration + ' (' + this.PopupArray[i].code + ')', ch: ch, visible: true })
      }
    }

    var selAZonesId = this.navParams.get("selAZonesId")
    if (this.PopupType == 'alert-allowedzones') {
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        for (var j = 0; j < selAZonesId.length; j++) {
          if (selAZonesId[j] + '' == this.PopupArray[i].id + '') {
            ch = true
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, ch: ch, visible: true })
      }
    }


    if (this.PopupType == 'agrrep') {
      var selConnMechId = this.navParams.get('selConnMechId')
      var chAll = false
      if (selConnMechId.length - 1 == this.gn.BeaconConnMech.length || selConnMechId[0] + '' == '0')
        chAll = true;
      this.popData.push({ id: 0, title: '', name: this.dic.l["allConnMech"], operation: '', ch: chAll, visible: true })
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        if (selConnMechId[0] + '' == '0')
          ch = true
        else {
          for (var j = 0; j < selConnMechId.length; j++) {
            if (selConnMechId[j] + '' == this.PopupArray[i].id + '') {
              ch = true
            }
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, operation: this.PopupArray[i].operation, ch: ch, visible: true })
      }
    }
    if (this.PopupType == 'agrrep1') {
      var selOperId = this.navParams.get('selOperId')
      var chAll = false
      if (selOperId.length - 1 == this.gn.AgrOperations.length || selOperId[0] + '' == '0')
        chAll = true;
      this.popData.push({ id: 0, title: '', name: this.dic.l["allOperations"], operation: '', ch: chAll, visible: true })
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        if (selOperId[0] + '' == '0')
          ch = true
        else {
          for (var j = 0; j < selOperId.length; j++) {
            if (selOperId[j] + '' == this.PopupArray[i].id + '') {
              ch = true
            }
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, operation: '', ch: ch, visible: true })
      }
    }
    if (this.PopupType == 'costtype') {
      var selCostTypeId = this.navParams.get('selCostTypeId')
      var chAll = false
      if (selCostTypeId.length - 1 == this.gn.Costs.length || selCostTypeId[0] + '' == '0')
        chAll = true;
      this.popData.push({ id: 0, title: '', name: this.dic.l["allCosts"], cost: '', ch: chAll, visible: true })
      for (var i = 0; i < this.PopupArray.length; i++) {
        var ch = false
        if (selCostTypeId[0] + '' == '0')
          ch = true
        else {
          for (var j = 0; j < selCostTypeId.length; j++) {
            if (selCostTypeId[j] + '' == this.PopupArray[i].id + '') {
              ch = true
            }
          }
        }
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name, cost: '', ch: ch, visible: true })
      }
    }



    if (this.PopupType == 'vehicles' || this.PopupType == 'vehicles-live') {
      if (this.PopupSelected[0] == "0" || this.PopupSelected.length == 0) this.vehInRoute = false

      _that.popData = []
      if (_that.vehiclepulses == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)

        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowfuelpulses == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowfuelpulses == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }
      //drisla cisterna
      if (_that.vehicletank == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)

        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].istank == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].istank == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }
      }
      //end drisla cisterna

      //digalka analogna
      if (_that.vehicledigalkaanalogna == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].isdigalkanalogna == '1' && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].isdigalkanalogna == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].isdigalkanalogna == '1' && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].isdigalkanalogna == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }
      }
      //end digalka analogna

      if (_that.bluetoothtemp == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].albletemp == '1' && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].albletemp == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].albletemp == '1' && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].albletemp == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }

      if (_that.electricveh == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].electric == '1' && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].electric == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].electric == '1' && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].electric == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }

      if (_that.tachogram == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowtacho == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowtacho == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }
      if (_that.beacon == 1 && _that.PopupType != 'agrrep') {
        //ako e zk ad i ako e izv za zemj oper i samohodkite da gi dodade fiksno nekako po id
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)

        //samohodki zk : 7495, 7494, 7493, 7492
        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].allowbeacon == '1' ||
              (_that.agrtf + '' == '1' && (
                //samohodki
                _that.gn.Vehicles[j].vehicleid + '' == '7495' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7494' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7493' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7492' ||
                //kombajni
                _that.gn.Vehicles[j].vehicleid + '' == '7496' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7565' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7500' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7594' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7499' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7498' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7590' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7595' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7563' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7564' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7591' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7593' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7592' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7596'

              )))) {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            //debugger
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].allowbeacon == '1' || (_that.agrtf + '' == '1' && (
                //samohodki
                _that.gn.Vehicles[j].vehicleid + '' == '7495' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7494' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7493' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7492' ||
                //kombajni
                _that.gn.Vehicles[j].vehicleid + '' == '7496' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7565' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7500' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7594' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7499' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7498' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7590' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7595' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7563' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7564' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7591' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7593' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7592' ||
                _that.gn.Vehicles[j].vehicleid + '' == '7596'
              )))) {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }

      if (_that.indoorbeacon == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allEmployees"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Beacons.length; j++) {
          if (_that.gn.Beacons[j].organisationid == 0) {
            _gr3.data.push({ id: _that.gn.Beacons[j].id, title: _that.gn.Beacons[j].vehicle + ' (' + _that.gn.Beacons[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          //var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }

          for (var j = 0; j < _that.gn.Beacons.length; j++) {
            if (_that.gn.Beacons[j].organisationid == _that.gn.Organisations[i].id) {
              //if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowbeacon == '1') {
              _gr2.data.push({ id: _that.gn.Beacons[j].id, title: _that.gn.Beacons[j].vehicle + ' (' + _that.gn.Beacons[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname })
              //}
            }
          }
          _that.popData.push(_gr2)
        }
      }


      if (_that.fuel == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)


        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowfuel == '1') {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowfuel == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }

      //cbfuel

      if (_that.cbfuel == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)


        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].a_cbf == '1' || _that.gn.Vehicles[j].organisationid + '' == '888')) {

              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].a_cbf == '1' || _that.gn.Vehicles[j].organisationid + '' == '888')) {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }

      //end cbfuel


      //speedlimitbuzzer
      if (_that.speedlimitbuzzer == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)


        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].speedlimitalertallow == '1') {
              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].speedlimitalertallow == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }
      //end speedlimitbuzzer




      //draeger
      if (_that.draegerdata == 1) {
        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)


        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowdraeger == '1') {
              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
            }
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && _that.gn.Vehicles[j].allowdraeger == '1') {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }
      //end draeger


      if (_that.securitystatereport == 1 || _that.techmalfunction == 1 || _that.baddrivingvehilces == 1 || _that.trafficrules == 1) {

        var ch = false
        if (this.OnlyOneVehicle == false) {
          _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)


        // _that.popData.push(_gr3)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].equipment == 'allcan300' || _that.gn.Vehicles[j].equipment == 'lvcan200'))
              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if (((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || _that.PopupType == 'vehicles') && (_that.gn.Vehicles[j].equipment == 'allcan300' || _that.gn.Vehicles[j].equipment == 'lvcan200')) {
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
              }
            }
          }
          _that.popData.push(_gr2)
        }

      }


      if (_that.securitystatereport != 1 && _that.vehiclepulses != 1 && _that.vehicletank != 1 && _that.tachogram != 1 && _that.beacon != 1 && _that.indoorbeacon != 1 && _that.fuel != 1 && _that.cbfuel != 1 && _that.speedlimitbuzzer != 1 && _that.draegerdata != 1 && _that.techmalfunction != 1 && _that.bluetoothtemp != 1 && _that.electricveh != 1 && _that.vehicledigalkaanalogna != '1' && _that.baddrivingvehilces != 1 && _that.trafficrules != 1) {
        var ch = false
        if (_that.indoorbeacon == 1) {
          if (this.OnlyOneVehicle == false) {
            _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allEmployees"], checked: false }] })
          }
        } else {
          if (this.OnlyOneVehicle == false) {
            _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
          }
        }
        // var _gr = { id: 0, title: '', data: [] }
        var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
        var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
        _that.popData.push(_gr4)

        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
            if ((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || (_that.PopupType == 'vehicles' && _that.gn.Vehicles[j].istank == '0' && _that.gn.Vehicles[j].allowfuelpulses == '0'))
              _gr3.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"],
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
          }
        }
        _that.popData.push(_gr3)

        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
          for (var j = 0; j < _that.gn.Vehicles.length; j++) {
            if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
              if ((_that.PopupType == 'vehicles-live' && _that.gn.Vehicles[j].visible + '' == '1') || (_that.PopupType == 'vehicles' && _that.gn.Vehicles[j].istank == '0' && _that.gn.Vehicles[j].allowfuelpulses == '0'))
                _gr2.data.push({
                  id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false, org: _that.gn.Vehicles[j].organisationid, orgname: _that.gn.Vehicles[j].orgname,
                  visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
                })
            }
          }
          _that.popData.push(_gr2)
        }
      }


      var forsplice = []

      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true
            // console.log(_that.PopupSelected[k], '_that.PopupSelected[k]')
            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                // console.log('kako tuka vo ionviewdidload  I')
                _that.popData[i].data[j].checked = true

                forsplice.push(_that.popData[i].data[j])
                // rekonstrukcija
                if (this.OnlyOneVehicle == false) {
                  _that.popData[1].data.push(_that.popData[i].data[j])
                } else {
                  _that.popData[0].data.push(_that.popData[i].data[j])
                }
                _that.idfirstvehdragfalse.push(_that.popData[i].data[j].id)


                cntchecked++;

              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }

        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }

      }

      // if (_that.popData[0].checked == true) {
      //   _that.popData[1].data = []
      // } else {
      // if (_that.popData[0].checked == false) {
      //   _that.popData[1].data = []


      // poradi rekonstrucika only one vehicle
      if (this.OnlyOneVehicle == false) {


        if (_that.popData[0].data[0].checked == true) {

        } else {
          for (let pp = 2; pp < _that.popData.length; pp++) {

            if (_that.popData[pp].data.length > 0) {

              if (_that.popData[pp].checked == true) {
                _that.popData[pp].data = []
              } else {
                var jj = _that.popData[pp].data.length
                while (jj--) {
                  for (let cc = 0; cc < forsplice.length; cc++) {
                    if (_that.popData[pp].data[jj] != undefined) {

                      if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                        _that.popData[pp].data.splice(jj, 1)
                      }
                    }
                  }
                }

              }
            }
          }
        }

      } else {
        for (let pp = 1; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }
            }

          }
        }
      }


      // }

      // }





      // for (let jj = _that.popData[pp].data.length; jj < _that.popData[pp].data.length; jj--) {
      //   for (let cc = 0; cc < forsplice.length; cc++) {
      //     // if (_that.popData[pp].data.length > 0) {
      //     debugger
      //     if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
      //       _that.popData[pp].data.splice(jj, 1)
      //       // forsplice.splice(c, 1)
      //     }
      //   }
      // }

      // if (splices.length > 0) {
      //   for (let cc = 0; cc < splices.length; cc++) {
      //     debugger
      //     var tmp = _that.popData[splices[cc].i].data[splices[cc].j]
      //     _that.popData[splices[cc].i].data.splice(splices[cc].j, 1)
      //     _that.popData[1].data.push(tmp)
      //   }
      // }


      // for (let i = 0; i < forsplice.length; i++) {
      //   for (let p = 0; p < this.length; p++) {
      //     const element = array[p];

      //   }
      // }





      // if (this.PopupType == 'vehicles-live') {
      //   if (this.vehInRoute) {
      //     this.showVehiclesRoute(1, this.vehInRoute)
      //   }
      //   if (this.vehOutRoute) {
      //     this.showVehiclesRoute(0, this.vehOutRoute)
      //   }
      // }

    }

    if (this.PopupType == 'vehicles-follow-live') {
      // console.log('@@@@' + this.gn.Vehicles[0].follow)
      _that.popData = []
      // console.log(_that.popData, 'sto se slicuva ovde')
      // console.log('ovdeeee !!!')
      // console.log(_that.gn.Vehicles)
      var ch = false

      // var _gr = { id: 0, title: '', data: [] }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // _that.popData.push(_gr3)

      for (var j = 0; j < _that.gn.Vehicles.length; j++) {
        if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
          if ((_that.PopupType == 'vehicles-follow-live') && _that.gn.Vehicles[j].visible + '' == '1')
            _gr3.data.push({
              id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false,
              visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
            })
        }
      }
      _that.popData.push(_gr3)

      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
            if ((_that.PopupType == 'vehicles-follow-live') && _that.gn.Vehicles[j].visible + '' == '1')
              _gr2.data.push({
                id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false,
                visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
              })
          }
        }
        _that.popData.push(_gr2)
      }

      // console.log(_that.popData, 'daj be da te vidam sto ke mi dadesh')
      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id + '' != '-1') {
              var selFollVeh = this.gn.getCookie("selfollvehids");
              var selFollVehIDs = JSON.parse("[" + selFollVeh + "]")

              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = false
              _that.popData[i].data[j].checked = false
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
    }

    if (this.PopupType == 'driverrep') {
      // console.log(this.alldrivers, 'daj da vidam all drivers')
      // console.log(this.PopupSelected, 'popupselected')

      _that.popData = []
      // console.log(_that.popData, 'sto se slicuva ovde')
      // console.log('ovdeeee !!!')
      // console.log(_that.gn.Vehicles)
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allDrivers"], checked: false }] })
      }
      // var _gr = { id: 0, title: '', data: [] }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
      var _gr5 = ({ id: -3, title: 'bezrfid', data: [], checked: false })

      _that.popData.push(_gr4)

      for (var j = 0; j < _that.alldrivers.length; j++) {
        // if (_that.alldrivers[j].rfid != '') {
        //   _gr4.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false })
        // }
        if (_that.alldrivers[j].organisationid == 0) {
          _gr3.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        }
      }
      _that.popData.push(_gr3) //_gr4)

      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
        for (var j = 0; j < _that.alldrivers.length; j++) {
          if (_that.alldrivers[j].organisationid == _that.gn.Organisations[i].id) {
            _gr2.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false, org: _that.alldrivers[j].organisationid, orgname: _that.gn.Organisations[i].name })
          }
        }
        _that.popData.push(_gr2)
      }
      var forsplice = []
      // console.log(_that.popData, 'daj be da te vidam sto ke mi dadesh')
      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }


    if (this.PopupType == 'userdriverrep') {
      // console.log(this.alldrivers, 'daj da vidam all drivers')
      // console.log(this.PopupSelected, 'popupselected')

      _that.popData = []
      // console.log(_that.popData, 'sto se slicuva ovde')
      // console.log('ovdeeee !!!')
      // console.log(_that.gn.Vehicles)
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allDrivers"], checked: false }] })
      }
      // var _gr = { id: 0, title: '', data: [] }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // var _gr4 = ({ id: -2, title: 'bezrfid', data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })
      _that.popData.push(_gr4) //_gr4)



      // _that.popData.push(_gr3)

      for (var j = 0; j < _that.alldrivers.length; j++) {
        // if (_that.alldrivers[j].rfid != '') {
        //   _gr4.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false })
        // }
        if (_that.alldrivers[j].organisationid == 0 && _that.alldrivers[j].isdriver == '1') {
          _gr3.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        }
      }
      _that.popData.push(_gr3) //_gr4)

      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
        for (var j = 0; j < _that.alldrivers.length; j++) {
          if (_that.alldrivers[j].organisationid == _that.gn.Organisations[i].id && _that.alldrivers[j].isdriver == '1') {
            _gr2.data.push({ id: _that.alldrivers[j].id, title: _that.alldrivers[j].fullname, checked: false, org: _that.alldrivers[j].organisationid, orgname: _that.gn.Organisations[i].name })
          }
        }
        _that.popData.push(_gr2)
      }
      var forsplice = []

      // console.log(_that.popData, 'daj be da te vidam sto ke mi dadesh')
      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }


    if (this.PopupType == 'beaconrep') {
      _that.popData = []
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allDrivers"], checked: false }] })
      }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // var _gr4 = ({ id: -2, title: 'bezrfid', data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })

      _that.popData.push(_gr4) //_gr4)


      for (var j = 0; j < _that.gn.Beacons.length; j++) {
        if (_that.gn.Beacons[j].organisationid == 0) {
          _gr3.data.push({ id: _that.gn.Beacons[j].id, title: _that.gn.Beacons[j].vehicle + ' (' + _that.gn.Beacons[j].code + ')', checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        }
      }
      _that.popData.push(_gr3) //_gr4)

      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
        for (var j = 0; j < _that.gn.Beacons.length; j++) {
          if (_that.gn.Beacons[j].organisationid == _that.gn.Organisations[i].id) {
            _gr2.data.push({ id: _that.gn.Beacons[j].id, title: _that.gn.Beacons[j].vehicle + ' (' + _that.gn.Beacons[j].code + ')', checked: false, org: _that.gn.Organisations[i].id, orgname: _that.gn.Organisations[i].name })
          }
        }
        _that.popData.push(_gr2)
      }
      var forsplice = []

      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }

    if (this.PopupType == 'processindoor') {
      _that.popData = []
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allProcess"], checked: false }] })
      }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // var _gr4 = ({ id: -2, title: 'bezrfid', data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })

      _that.popData.push(_gr4) //_gr4)


      for (var j = 0; j < _that.gn.allprocess.length; j++) {
        // if (_that.gn.allprocess[j].organisationid == 0) {
        _gr3.data.push({ id: _that.gn.allprocess[j].id, title: _that.gn.allprocess[j].processname, checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        // }
      }
      _that.popData.push(_gr3) //_gr4)

      // for (var i = 0; i < _that.gn.Organisations.length; i++) {
      //   var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
      //   for (var j = 0; j < _that.gn.allprocess.length; j++) {
      //     if (_that.gn.allprocess[j].organisationid == _that.gn.Organisations[i].id) {
      //       _gr2.data.push({ id: _that.gn.allprocess[j].id, title: _that.gn.allprocess[j].processname, checked: false, org: _that.gn.Organisations[i].id })
      //     }
      //   }
      //   _that.popData.push(_gr2)
      // }

      var forsplice = []

      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }

    if (this.PopupType == 'articleindoor') {
      _that.popData = []
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allArticles"], checked: false }] })
      }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // var _gr4 = ({ id: -2, title: 'bezrfid', data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })

      _that.popData.push(_gr4) //_gr4)


      for (var j = 0; j < _that.gn.allarticles.length; j++) {
        // if (_that.gn.allarticles[j].organisationid == 0) {
        _gr3.data.push({ id: _that.gn.allarticles[j].id, title: _that.gn.allarticles[j].name, checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        // }
      }
      _that.popData.push(_gr3) //_gr4)

      // for (var i = 0; i < _that.gn.Organisations.length; i++) {
      //   var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
      //   for (var j = 0; j < _that.gn.allarticles.length; j++) {
      //     if (_that.gn.allarticles[j].organisationid == _that.gn.Organisations[i].id) {
      //       _gr2.data.push({ id: _that.gn.allarticles[j].id, title: _that.gn.allarticles[j].processname, checked: false, org: _that.gn.Organisations[i].id })
      //     }
      //   }
      //   _that.popData.push(_gr2)
      // }
      var forsplice = []

      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }

    if (this.PopupType == 'employeeindoor') {
      _that.popData = []
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allEmployees"], checked: false }] })
      }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // var _gr4 = ({ id: -2, title: 'bezrfid', data: [], checked: false })
      var _gr4 = ({ id: -2, title: _that.dic.l["Selected"], data: [], checked: false })

      _that.popData.push(_gr4) //_gr4)


      for (var j = 0; j < _that.gn.allpinusers.length; j++) {
        // if (_that.gn.allpinusers[j].organisationid == 0) {
        _gr3.data.push({ id: _that.gn.allpinusers[j].id, title: _that.gn.allpinusers[j].fullname, checked: false, org: -1, orgname: _that.dic.l["Ungroupped"] })
        // }
      }

      _that.popData.push(_gr3) //_gr4)

      // for (var i = 0; i < _that.gn.Organisations.length; i++) {
      //   var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
      //   for (var j = 0; j < _that.gn.allpinusers.length; j++) {
      //     if (_that.gn.allpinusers[j].organisationid == _that.gn.Organisations[i].id) {
      //       _gr2.data.push({ id: _that.gn.allpinusers[j].id, title: _that.gn.allpinusers[j].processname, checked: false, org: _that.gn.Organisations[i].id })
      //     }
      //   }
      //   _that.popData.push(_gr2)
      // }
      var forsplice = []

      for (var i = 0; i < _that.popData.length; i++) {

        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true
          }

          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]

            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {

                _that.popData[i].data[j].checked = true
                cntchecked++;
                forsplice.push(_that.popData[i].data[j])
                _that.popData[1].data.push(_that.popData[i].data[j])
                // _that.popData[i].data[j].visible = true
                // _that.popData[i].visible = true;
              }
            } else {

              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }
          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }
      if (_that.popData[0].data[0].checked == true) {

      } else {
        for (let pp = 2; pp < _that.popData.length; pp++) {

          if (_that.popData[pp].data.length > 0) {

            if (_that.popData[pp].checked == true) {
              _that.popData[pp].data = []
            } else {
              var jj = _that.popData[pp].data.length
              while (jj--) {
                for (let cc = 0; cc < forsplice.length; cc++) {
                  if (_that.popData[pp].data[jj] != undefined) {

                    if (_that.popData[pp].data[jj].id == forsplice[cc].id) {
                      _that.popData[pp].data.splice(jj, 1)
                    }
                  }
                }
              }

            }
          }
        }
      }
    }


    if (this.PopupType == 'alldriversandvehicles') {
      this.gn._Post('/api/gn/getalldriversandvehicles', { cid: _that.gn.crypt(this.gn.user.ClientId) }, function (_data) {
        for (var k = 0; k < _data.length; k++) {
          _that.popData.push({ id: _data[k].driverid, name: _data[k].drivername, visible: true, checked: false })
        }

      })
    }




    if (this.PopupType == 'scheduler') {
      var vehScheduleId = this.navParams.get('scheduleidselectedveh')
      // console.log(vehScheduleId, 'daj id od predhodno vozilo')


      _that.popData = []
      // console.log(_that.popData, 'sto se slicuva ovde')
      // console.log('ovdeeee !!!')
      // console.log(_that.gn.Vehicles)
      var ch = false
      if (this.OnlyOneVehicle == false) {
        _that.popData.push({ id: 0, title: '', data: [{ id: 0, title: _that.dic.l["allvehicles"], checked: false }] })
      }
      // var _gr = { id: 0, title: '', data: [] }
      var _gr3 = ({ id: -1, title: _that.dic.l["Ungroupped"], data: [], checked: false })
      // _that.popData.push(_gr3)

      for (var j = 0; j < _that.gn.Vehicles.length; j++) {
        if (_that.gn.Vehicles[j].organisationid == 0 && _that.gn.Vehicles[j].nopay == '0') {
          _gr3.data.push({
            id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false,
            visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
          })
        }
      }
      _that.popData.push(_gr3)

      for (var i = 0; i < _that.gn.Organisations.length; i++) {
        var _gr2 = { id: _that.gn.Organisations[i].id, title: _that.gn.Organisations[i].code + '. ' + _that.gn.Organisations[i].name, data: [], checked: false }
        for (var j = 0; j < _that.gn.Vehicles.length; j++) {
          if (_that.gn.Vehicles[j].organisationid == _that.gn.Organisations[i].id && _that.gn.Vehicles[j].nopay == '0') {
            _gr2.data.push({
              id: _that.gn.Vehicles[j].vehicleid, model: _that.gn.Vehicles[j].model, alias: _that.gn.Vehicles[j].alias, title: _that.gn.Vehicles[j].registration + ' (' + _that.gn.Vehicles[j].code + ')', checked: false,
              visible_veh: _that.gn.Vehicles[j].visible, approve: _that.gn.Vehicles[j].approve, suspend: _that.gn.Vehicles[j].suspend
            })
          }
        }
        _that.popData.push(_gr2)
      }
      // console.log(_that.popData, 'daj be da te vidam sto ke mi dadesh')
      // console.log(vehScheduleId.split(',')
      //   , 'daj da vidam predhodni')
      // _that.PopupSelected.push(vehScheduleId.split(','))
      // console.log(_that.PopupSelected,'')
      // console.log(_that.PopupSelected, 'ima li nesto tuka')
      for (var i = 0; i < _that.popData.length; i++) {
        var cntchecked = 0;
        for (var j = 0; j < _that.popData[i].data.length; j++) {
          // console.log(vehScheduleId == _that.popData[i].data[j].id, 'daj da vidam dali e true')


          _that.popData[i].visible = true;

          if (_that.PopupSelected.length == 0) {
            // _that.popData[i].data[j].checked = false
            _that.popData[i].data[j].visible = true

          }
          // console.log(_that.PopupSelected, 'daj da vidam')
          for (var k = 0; k < _that.PopupSelected.length; k++) {
            _that.popData[i].data[j].visible = true

            var _id = _that.PopupSelected[k]
            if (_id != 0) {
              if (_that.popData[i].data[j].id == _id) {
                _that.popData[i].data[j].checked = true
                cntchecked++;

              }
            }
            else {
              _that.popData[i].checked = true
              _that.popData[i].data[j].checked = true
              _that.popData[i].data[j].visible = true
            }

          }
        }
        if (cntchecked == _that.popData[i].data.length) {
          _that.popData[i].checked = true
          _that.popData[i].visible = true;
        }
      }


    }

    if (this.PopupType == 'city') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-pin-outline'
      this.gn._Post('/api/gn/getcities', {}, function (_data) {
        _that.popData = _data
      })
    }

    if (this.PopupType == 'resetDriver') {
      this.PopupType2 = 'ResetDriver'
      this.generalIcon = 'ios-log-out-outline'
      this.gn._Post('/api/gn/getresetdriver', {}, function (_data) {
        _that.popData = _data
      })
    }

    if (this.PopupType == 'country') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-globe-outline'
      this.gn._Post('/api/gn/getcountry', {}, function (_data) {
        _that.popData = _data
      })
    }
    if (this.PopupType == 'snooze') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-alarm-outline'
      this.popData.push({ id: 0, name: this.dic.l["dnr"] })
      this.popData.push({ id: 2, name: '2 ' + this.dic.l["min"] })
      this.popData.push({ id: 4, name: '4 ' + this.dic.l["min"] })
      this.popData.push({ id: 6, name: '6 ' + this.dic.l["min"] })
      this.popData.push({ id: 8, name: '8 ' + this.dic.l["min"] })
      this.popData.push({ id: 10, name: '10 ' + this.dic.l["min"] })
    }
    if (this.PopupType == 'fuelunit') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-water-outline'
      this.popData.push({ id: "litar", name: this.dic.l["litar"] })
      this.popData.push({ id: "galon", name: this.dic.l["galon"] })
    }
    if (this.PopupType == 'currency') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-cash-outline'
      this.gn._Post('/api/gn/currency', {}, function (_data) {
        _that.popData = _data
      })
    }
    if (this.PopupType == 'map') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-map-outline'
      this.popData.push({ id: "GOOGLES", name: "Google satellite" })
      this.popData.push({ id: "GOOGLEM", name: "Google Map" })
      this.popData.push({ id: "OSMM", name: "Openstreet Map" })
    }
    if (this.PopupType == 'rperiod') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-refresh-outline'
      this.popData.push({ id: "never", name: this.dic.l["never"] })
      this.popData.push({ id: "monthly", name: this.dic.l["monthly"] })
      this.popData.push({ id: "yearly", name: this.dic.l["yearly"] })
    }
    if (this.PopupType == 'fueltank') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-resize-outline'
      this.popData.push({ id: "0", name: "0cm" })
      this.popData.push({ id: "1", name: "1cm" })
      this.popData.push({ id: "2", name: "2cm" })
      this.popData.push({ id: "3", name: "3cm" })
    }
    if (this.PopupType == 'assigndriver') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-timer-outline'
      this.popData.push({ id: 1, name: this.dic.l["now"] })
      this.popData.push({ id: 2, name: this.dic.l["future"] })
    }
    if (this.PopupType == 'dtformat') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      this.popData.push({ id: "d-m-Y H:i:s", name: "DD-MM-YYYY HH:mm:ss" })
      this.popData.push({ id: "m-d-Y H:i:s", name: "MM-DD-YYYY HH:mm:ss" })
      this.popData.push({ id: "Y-m-d H:i:s", name: "YYYY-MM-DD HH:mm:ss" })
      this.popData.push({ id: "d-m-Y h:i:s a", name: "DD-MM-YYYY hh:mm:ss a" })
      this.popData.push({ id: "m-d-Y h:i:s a", name: "MM-DD-YYYY hh:mm:ss a" })
      this.popData.push({ id: "Y-m-d h:i:s a", name: "YYYY-MM-DD hh:mm:ss a" })
    }
    if (this.PopupType == 'metric') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-resize-outline'
      this.popData.push({ id: "km", name: this.dic.l["km"] })
      this.popData.push({ id: "mi", name: this.dic.l["mi"] })
    }
    if (this.PopupType == 'tempunit') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-thermometer-outline'
      this.popData.push({ id: "C", name: "°C" })
      this.popData.push({ id: "F", name: "°F" })
    }
    if (this.PopupType == 'startpage') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-home-outline'
      this.popData.push({ id: "0", name: this.dic.l["startpage0"] })
      this.popData.push({ id: "1", name: this.dic.l["startpage1"] })
    }
    if (this.PopupType == 'trajectory') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'logo-steam'
      for (var i = 1; i <= 18; i++) {
        this.popData.push({ id: i * 10, name: (i * 10) + ' ' + this.dic.l["min"] })
      }
    }

    if (this.PopupType == 'idleover') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-timer-outline'
      for (var i = 2; i <= 10; i++) {
        this.popData.push({ id: i, name: this.dic.l["morethan"] + ' ' + i + ' ' + this.dic.l["min"] })
      }
    }
    if (this.PopupType == 'color') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-color-palette-outline'
      this.popData.push({ id: 1, name: this.dic.l["color1"] })
      this.popData.push({ id: 2, name: this.dic.l["color2"] })
      this.popData.push({ id: 3, name: this.dic.l["color3"] })
      this.popData.push({ id: 4, name: this.dic.l["color4"] })
      this.popData.push({ id: 5, name: this.dic.l["color5"] })
      this.popData.push({ id: 6, name: this.dic.l["color6"] })
      this.popData.push({ id: 7, name: this.dic.l["color7"] })
      this.popData.push({ id: 8, name: this.dic.l["color8"] })
      this.popData.push({ id: 9, name: this.dic.l["color9"] })
    }
    if (this.PopupType == 'time') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      var hour = new Date().getHours() + 1 + ":00";
      this.popData.push({ id: hour, name: hour })
      for (var i = 0; i <= 23; i++) {
        var h = i + '';
        if (h.length < 2) {
          h = '0' + h;
        }
        this.popData.push({ id: h + ':00', name: h + ':00' })
        this.popData.push({ id: h + ':15', name: h + ':15' })
        this.popData.push({ id: h + ':30', name: h + ':30' })
        this.popData.push({ id: h + ':45', name: h + ':45' })
      }
    }
    if (this.PopupType == 'quantity') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-apps-outline'
      this.popData.push({ id: '1', name: '1' })
      this.popData.push({ id: '2', name: '2' })
      this.popData.push({ id: '3', name: '3' })
      this.popData.push({ id: '4', name: '4' })
      this.popData.push({ id: '5', name: '5' })
      this.popData.push({ id: '6', name: '6' })
      this.popData.push({ id: '7', name: '7' })
      this.popData.push({ id: '8', name: '8' })
      this.popData.push({ id: '9', name: '9' })
      this.popData.push({ id: '10', name: '10' })
      this.popData.push({ id: '11', name: '11' })
      this.popData.push({ id: '12', name: '12' })
      this.popData.push({ id: '13', name: '13' })
      this.popData.push({ id: '14', name: '14' })
      this.popData.push({ id: '15', name: '15' })
      this.popData.push({ id: '16', name: '16' })
      this.popData.push({ id: '17', name: '17' })
      this.popData.push({ id: '18', name: '18' })
      this.popData.push({ id: '19', name: '19' })
      this.popData.push({ id: '20', name: '20' })
    }
    if (this.PopupType == 'timeodometer') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      var hour = new Date().getHours() + 1 + ":00";
      this.popData.push({ id: hour, name: hour })
      for (var i = 0; i <= 23; i++) {
        var h = i + '';
        if (h.length < 2) {
          h = '0' + h;
        }
        this.popData.push({ id: h + ':00', name: h + ':00' })
        this.popData.push({ id: h + ':05', name: h + ':05' })
        this.popData.push({ id: h + ':10', name: h + ':10' })
        this.popData.push({ id: h + ':15', name: h + ':15' })
        this.popData.push({ id: h + ':20', name: h + ':20' })
        this.popData.push({ id: h + ':25', name: h + ':25' })
        this.popData.push({ id: h + ':30', name: h + ':30' })
        this.popData.push({ id: h + ':35', name: h + ':35' })
        this.popData.push({ id: h + ':40', name: h + ':40' })
        this.popData.push({ id: h + ':45', name: h + ':45' })
        this.popData.push({ id: h + ':50', name: h + ':50' })
        this.popData.push({ id: h + ':55', name: h + ':55' })
      }
    }
    if (this.PopupType == 'timerec') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      // var hour = new Date().getHours() + 1 + ":00";
      // this.popData.push({ id: hour, name: hour })
      for (var i = 0; i <= 23; i++) {
        var h = i + '';
        if (h.length < 2) {
          h = '0' + h;
        }
        this.popData.push({ id: h + ':00', name: h + ':00' })
        this.popData.push({ id: h + ':15', name: h + ':15' })
        this.popData.push({ id: h + ':30', name: h + ':30' })
        this.popData.push({ id: h + ':45', name: h + ':45' })
      }
      this.popData.push({ id: '23:59', name: '23:59' })

    }

    if (this.PopupType == 'timeassignment') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      // var hour = new Date().getHours() + 1 + ":00";
      // this.popData.push({ id: hour, name: hour })
      for (var i = 0; i <= 23; i++) {
        var h = i + '';
        if (h.length < 2) {
          h = '0' + h;
        }
        this.popData.push({ id: h + ':00', name: h + ':00' })
        this.popData.push({ id: h + ':30', name: h + ':30' })
      }
    }

    if (this.PopupType == 'timeprotocol') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-clock-outline'
      // var hour = new Date().getHours() + 1 + ":00";
      // this.popData.push({ id: hour, name: hour })
      for (var i = 0; i <= 23; i++) {
        var h = i + '';
        if (h.length < 2) {
          h = '0' + h;
        }
        this.popData.push({ id: h + ':00', name: h + ':00' })
        this.popData.push({ id: h + ':30', name: h + ':30' })
      }
    }

    if (this.PopupType == 'beacon-type') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-list-outline'
      this.popData.push({ id: "Beacon-ID", name: "ID" })
      this.popData.push({ id: "Beacon-PersonID", name: "PersonID" })
      this.popData.push({ id: "Beacon-Magnet", name: "Magnet" })
      this.popData.push({ id: "Beacon-Movement", name: "Movement" })
      this.popData.push({ id: "Beacon-Asset", name: "Asset" })
    }

    if (this.PopupType == 'expense') {
      this.PopupType2 = 'expense'
      this.generalIcon = 'ios-cart-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].costname })
      }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'vendor') {
      this.PopupType2 = 'vendor'
      this.generalIcon = 'ios-analytics-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].vendor })
      }
      this.viewSearchOthers()
    }

    if (this.PopupType == 'Drivers') {
      this.PopupType2 = 'DriversOther'
      this.generalIcon = 'ios-contact-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name })
      }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'PPaths') {
      this.PopupType2 = 'PPathsOther'
      this.generalIcon = 'ios-cube-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name })
      }
      this.viewSearchOthers()
    }

    if (this.PopupType == 'PaymentType' || this.PopupType == 'PaymentGroupType') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-card-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].cardname })
      }
    }
    if (this.PopupType == 'ddv') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-cash-outline'
      for (var i = 0; i < this.PopupArray.length; i++) {
        this.popData.push({ id: this.PopupArray[i].id, name: this.PopupArray[i].name })
      }
    }

    if (this.PopupType == 'disabledvehmenu') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-settings-outline'
      this.popData.push({ id: "1", name: this.dic.l["Activate"] })
      this.popData.push({ id: "2", name: this.dic.l["costs"], priv: this.gn.clientsettings.allowedfm })
      this.popData.push({ id: "3", name: this.dic.l["Driver"] })
    }
    if (this.PopupType == 'enabledvehmenu') {
      var _that = this
      _that.PopupType2 = 'Other'
      _that.generalIcon = 'ios-settings-outline'

      //obicnite useri na sedmica da gledaat samo izvestaj za ble temp za uredite sto se frizideri i imaat bletemp
      if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.navParams.get("vid")]].albletemp + '' == '1' && _that.gn.Vehicles[_that.gn.VehiclesDic[_that.navParams.get("vid")]].typeid + '' == '121') {
        _that.popData.push({ id: "19", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["Bluethoottempreport"], icon: 'ios-pie-outline' })
      } else {
        _that.popData.push({ id: "1", name: _that.dic.l["deActivate"], icon: 'ios-car-outline' })

        //Сирена (Horn) за возилата што се внесени како vehicleType=MOTORCICLES
        if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.navParams.get("vid")]].typeid + '' == '78') {
          _that.popData.push({ id: "21", name: _that.dic.l["horn"], priv: true, icon: 'ios-megaphone-outline' })
        }

        //if (_that.gn.user.UserId + '' == '2812') {
        //zk traktori blokada/deblokada
        if (this.navParams.get("vid") + '' == '5418' || this.gn.user.UserId + '' == '2896' || (this.gn.user.UserId + '' == '2812' && (this.navParams.get("vid") + '' == '6778' || this.navParams.get("vid") + '' == '2486' || this.navParams.get("vid") + '' == '3493' || this.navParams.get("vid") + '' == '2425'))) {
          if (this.gn.Vehicles[this.gn.VehiclesDic[this.navParams.get("vid")]].allowengineblock + '' == '1') {
            if (this.gn.Vehicles[this.gn.VehiclesDic[this.navParams.get("vid")]].engineblock + '' == '1') {
              _that.popData.push({ id: "18", name: _that.dic.l["unblock"], icon: 'ios-checkmark-circle-outline' })
            }
            if (this.gn.Vehicles[this.gn.VehiclesDic[this.navParams.get("vid")]].engineblock + '' == '0') {
              _that.popData.push({ id: "18", name: _that.dic.l["block"], icon: 'ios-close-circle-outline' })
            }
          } else {
            _that.popData.push({ id: "18", name: _that.dic.l["block"], priv: false, icon: 'ios-close-circle-outline' })
          }
        }

        _that.popData.push({ id: "2", name: _that.dic.l["costs"], priv: _that.gn.clientsettings.allowedfm, icon: 'ios-cart-outline', class: 'gn-line-through' })
        _that.popData.push({ id: "3", name: _that.dic.l["Driver"], icon: 'ios-person-outline' })
        _that.popData.push({ id: "4", name: _that.dic.l["message"], priv: _that.navParams.get("enabled"), icon: 'ios-chatbubbles-outline' })

        if (parseInt(_that.gn.clientsettings.hasallowgarmin + '') > 0) {
          if (this.gn.Vehicles[this.gn.VehiclesDic[this.navParams.get("vid")]].allowgarmin + '' == '1') {
            _that.popData.push({ id: "5", name: _that.dic.l["garmin"], priv: true, enabled: 'true', icon: 'ios-git-pull-request' })
          } else {
            _that.popData.push({ id: "5", name: _that.dic.l["garmin"], priv: false, enabled: 'true', icon: 'ios-git-pull-request' })
          }
        }

        _that.popData.push({ id: "6", name: _that.dic.l["viewroute"], priv: true, enabled: (_that.gn.clientsettings.allowedrouting + '' == '1' ? 'true' : 'false'), icon: 'ios-git-merge-outline' })

        _that.popData.push({ id: "7", name: _that.dic.l["dailyreview"], priv: true, icon: 'ios-grid-outline' })

        _that.popData.push({ id: "8", name: _that.dic.l["TachogramReport"], priv: true, enabled: (parseInt(_that.gn.clientsettings.hasallowtacho + '') > 0 ? 'true' : 'false'), icon: 'ios-help-buoy-outline' })
        //_that.popData.push({ id: "7", name: _that.dic.l["TachogramReport"], priv: true, enabled: 'false', icon: 'ios-help-buoy-outline' })

        _that.popData.push({ id: "9", name: _that.dic.l["copycoord"], icon: 'ios-copy-outline' })
        _that.popData.push({ id: "10", name: _that.dic.l["navigate"], icon: 'ios-navigate-outline' })

        //NEW LINK
        _that.popData.push({ id: "20", name: _that.dic.l["link"], icon: 'ios-git-network' })
        //END NEW LINK

        if (this.gn.Vehicles[this.gn.VehiclesDic[this.navParams.get("vid")]].armed + '' == '1') {
          _that.popData.push({ id: "11", name: 'DISARM', enabled: ((_that.gn.getPriv('armdisarm') && _that.gn.clientsettings.clienttypeid + '' == '7') ? 'true' : 'false'), icon: 'ios-unlock-outline' })
        } else {
          _that.popData.push({ id: "11", name: 'ARM', enabled: ((_that.gn.getPriv('armdisarm') && _that.gn.clientsettings.clienttypeid + '' == '7') ? 'true' : 'false'), icon: 'ios-lock-outline' })
        }

        _that.popData.push({ id: "12", name: _that.dic.l["roadDirection"], enabled: ((_that.gn.clientsettings.clienttypeid + '' == '7') ? 'true' : 'false'), icon: 'ios-flag-outline' })

        _that.popData.push({ id: "13", name: _that.dic.l["OverviewV"], icon: 'ios-pie-outline' })
        _that.popData.push({ id: "14", name: _that.dic.l["ShortReport"], icon: 'ios-pie-outline' })
        _that.popData.push({ id: "15", name: _that.dic.l["IdlingReport"], icon: 'ios-pie-outline' })
        _that.popData.push({ id: "16", name: _that.dic.l["VehiclePOI"], icon: 'ios-pie-outline' })
        _that.popData.push({ id: "17", name: _that.dic.l["reconstruction"], icon: 'ios-pie-outline' })
        // _that.popData.push({ id: "13", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["OverviewV"], icon: 'ios-pie-outline' })
        // _that.popData.push({ id: "14", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["ShortReport"], icon: 'ios-pie-outline' })
        // _that.popData.push({ id: "15", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["IdlingReport"], icon: 'ios-pie-outline' })
        // _that.popData.push({ id: "16", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["VehiclePOI"], icon: 'ios-pie-outline' })
        // _that.popData.push({ id: "17", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["reconstruction"], icon: 'ios-pie-outline' })
        // samo za sedmica
        if (_that.gn.Vehicles[_that.gn.VehiclesDic[_that.navParams.get("vid")]].albletemp + '' == '1') {
          _that.popData.push({ id: "19", name: _that.dic.l["reportone"] + ': ' + _that.dic.l["Bluethoottempreport"], icon: 'ios-pie-outline' })
        }
      }
    }
    if (this.PopupType == 'switchmap') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-map-outline'
      this.popData.push({ id: "GOOGLE", name: 'Google Maps' })
      this.popData.push({ id: "OSMM", name: 'Open Street Maps' })
    }
    if (this.PopupType == 'alerttypenlb') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-card-outline'
      this.popData.push({ id: "test", name: _that.dic.l["test"] })
      this.popData.push({ id: "other", name: _that.dic.l["other"] })
    }
    if (this.PopupType == 'poigroups') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-pin-outline'
      this.gn._Post('/api/gn/getpoigroups', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
        _data[0].name = _that.dic.l["All"]
        _that.popData = _data
      })
    }
    if (this.PopupType == 'staypois') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-git-commit'
      var _data = [{ id: 0, name: this.dic.l["All"] }, { id: 1, name: this.dic.l["withengineoff"] }, { id: 2, name: this.dic.l["withengineon"] }];
      this.popData = _data
    }
    if (this.PopupType == 'towups') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-open-outline'
      var _data = [{ id: 0, name: this.dic.l["All"] }, { id: 1, name: 'Во обид' }, { id: 2, name: 'По процедура' }];
      this.popData = _data
    }
    if (this.PopupType == 'vehicles-routing') {
      this.PopupType2 = 'VehCosts'
      this.generalIcon = 'ios-car-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["choosevehicle"] + ' ---' })
      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.gn.Vehicles[i].nopay == '0') {
          this.popData.push({
            id: this.gn.Vehicles[i].vehicleid, name: '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration, model: _that.gn.Vehicles[i].model, alias: _that.gn.Vehicles[i].alias,
            visible_veh: _that.gn.Vehicles[i].visible, approve: _that.gn.Vehicles[i].approve, suspend: _that.gn.Vehicles[i].suspend
          })
        }
      }
      this.viewSearchOthers()

    }
    if (this.PopupType == 'vehicles-beacon') {
      this.PopupType2 = 'VehCosts'
      this.generalIcon = 'ios-car-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["choosevehicle"] + ' ---' })
      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.gn.Vehicles[i].nopay == '0') {
          this.popData.push({
            id: this.gn.Vehicles[i].vehicleid, name: '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration, model: _that.gn.Vehicles[i].model, alias: _that.gn.Vehicles[i].alias,
            visible_veh: _that.gn.Vehicles[i].visible, approve: _that.gn.Vehicles[i].approve, suspend: _that.gn.Vehicles[i].suspend
          })
        }
      }
      // for (var i = 0; i < this.popData.length; i++) {
      //   if (this.allbk.filter(bk => bk.vehicleid === parseInt(this.popData[i].id)).length == 0)
      //     this.popData[i].visible = true
      // }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'vehicles-garmin') {
      this.PopupType2 = 'VehCosts'
      this.generalIcon = 'ios-car-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["choosevehicle"] + ' ---' })
      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.gn.Vehicles[i].allowgarmin + '' == '1' && this.gn.Vehicles[i].nopay == '0')
          this.popData.push({ id: this.gn.Vehicles[i].vehicleid, name: '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration })
      }
      // for (var i = 0; i < this.popData.length; i++) {
      //   if (this.allbk.filter(bk => bk.vehicleid === parseInt(this.popData[i].id)).length == 0)
      //     this.popData[i].visible = true
      // }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'employees-beacon') {
      this.PopupType2 = 'VehCosts'
      this.generalIcon = 'ios-person-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["chooseemployee"] + ' ---' })
      for (var i = 0; i < this.alldrivers.length; i++) {
        this.popData.push({ id: this.alldrivers[i].id, name: this.alldrivers[i].fullname })
      }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'asset-beacon') {
      this.PopupType2 = 'VehCosts'
      this.generalIcon = 'ios-git-commit-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["chooseasset"] + ' ---' })
      for (var i = 0; i < this.allassets.length; i++) {
        var _name = ''
        if (this.allassets[i].invnum != null && this.allassets[i].invnum != '') {
          _name = _name + this.allassets[i].invnum + ': '
        }
        _name = _name + this.allassets[i].name

        this.popData.push({ id: this.allassets[i].id, name: _name })
      }
      this.viewSearchOthers()
    }
    if (this.PopupType == 'routing-articles') {
      this.PopupType2 = 'articles'
      this.generalIcon = 'ios-cube-outline'

      this.popData.push({ id: -1, name: '--- ' + this.dic.l["chooseArticle"] + ' ---' })
      for (var i = 0; i < this.gn.Articles.length; i++) {
        this.popData.push({ id: this.gn.Articles[i].id, name: this.gn.Articles[i].name })
      }
      this.viewSearchOthers1()
    }

    if (this.PopupType == 'vehicles-trajectory') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-car-outline'
      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.gn.Vehicles[i].nopay == '0') {
          this.popData.push({ id: this.gn.Vehicles[i].vehicleid, name: '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration })
        }
      }

    }

    if (this.PopupType == 'typefuelcost') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-funnel-outline'
      this.popData = this.PopupArray
    }



    if (this.PopupType == 'vehsize') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-radio-button-off-outline'
      for (var i = 1; i <= 3; i++) {
        this.popData.push({ id: i, name: this.dic.l['vehsize' + i] })
      }
    }

    if (this.PopupType == 'addonmap') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-add-outline'
      if (parseInt(_that.gn.clientsettings.hasallowgarmin + '') > 0) {
        this.popData.push({ id: "GARMIN", name: this.dic.l['addgarmin'], priv: true })
      }
      this.popData.push({ id: "ZONE", name: this.dic.l['addzonemap'], priv: this.getPriv('addzones') })
      this.popData.push({ id: "POI", name: this.dic.l["AddPOImap"], priv: this.getPriv('addpoi') })
    }
    if (this.PopupType == 'fullnameuserslogs') {
      this.PopupType2 = 'Other'
      this.generalIcon = 'ios-contact-outline'
      this.popData.push({ id: "0", name: _that.dic.l['All'] })
      for (let i = 0; i < _that.gn.fullnameusers.length; i++) {
        this.popData.push({ id: _that.gn.fullnameusers[i].id, name: _that.gn.fullnameusers[i].fullname })

      }
      // this.popData.push({ id: "1", name: 'Виктор' })

    }

    if (this.PopupType == 'panorama-release') {
      this.PopupType2 = 'Panorama-Release'
      this.generalIcon = 'ios-car-outline'

      var _that = this
      _that.fillRV();
      var cb = this.navParams.get("callback")
      if (this.rvInterval == null) {
        _that.rvInterval = setInterval(function () {
          var _l = _that.popData.length;
          _that.fillRV();
          if (cb != null) {
            if (cb(_l).length > 0)
              _that.popData = cb(_l);
            if (_that.gn.user.lastreleaseversion + '' == '0') {
              _that.gn._Post('/api/gn/updaterelease', {
                uid: _that.gn.crypt(_that.gn.user.UserId)
              }, function (_data) {
                setTimeout(() => {
                  _that.gn.user.lastreleaseversion = '1';
                }, 11 * 1000);
              })
            }
          }
        }, 10 * 1000)
      }
    }
    if (this.PopupType == 'splitscreen') {
    }
  }

  ionViewWillLeave() {
    var _text = ''
    var _ids = []
    if (this.PopupType == 'vehicles' || this.PopupType == 'vehicles-live' || this.PopupType == 'vehicles-follow-live') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true || this.PopupType == 'vehicles-follow-live') {
        startIdx = 0
      }
      var tmp = []

      for (var i = startIdx; i < this.popData.length; i++) {
        // console.log(i)
        for (var j = 0; j < this.popData[i].data.length; j++) {
          // console.log(j, this.popData[i].data[j].checked)
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.Vehicles.length) {
        _text = this.dic.l["allvehicles"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["vehicles"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneVehicle"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }

      if (_text != '' || this.PopupType == 'vehicles-follow-live' || this.PopupType == 'vehicles-live') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          if (this.PopupType == 'vehicles-live') {
            cb(_text, _ids, this.vehInRoute, this.vehOutRoute)
          } else {
            cb(_text, _ids)
          }
        }
      }

    }

    if (this.PopupType == 'driverrep') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.alldrivers.length) {
        _text = this.dic.l["allDrivers"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Drivers"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneDriver"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'userdriverrep') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.alldrivers.length) {
        _text = this.dic.l["allDrivers"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Drivers"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneDriver"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'beaconrep') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.Beacons.length) {
        _text = this.dic.l["allEmployees"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Employees"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneEmloyee"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'processindoor') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.allprocess.length) {
        _text = this.dic.l["allProcess"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["process"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneProcess"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'articleindoor') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.allarticles.length) {
        _text = this.dic.l["allArticles"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Article"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneArticle"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }


    if (this.PopupType == 'employeeindoor') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.allpinusers.length) {
        _text = this.dic.l["allEmployees"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Employees"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneEmloyee"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'agrrep') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        if (this.popData[i].ch == true) {
          tmp.push(this.popData[i].name)
          _ids.push(this.popData[i].id)
        }
      }
      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.BeaconConnMech.length) {
        _text = this.dic.l["allConnMech"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["ConnectionMechanizations1"]
        }
      }
      if (_ids.length == 0) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneConnMech"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'agrrep1') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        if (this.popData[i].ch == true) {
          tmp.push(this.popData[i].name)
          _ids.push(this.popData[i].id)
        }
      }
      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.AgrOperations.length) {
        _text = this.dic.l["allOperations"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Operations1"]
        }
      }
      if (_ids.length == 0) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneOper"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'costtype') {
      var startIdx = 1
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        if (this.popData[i].ch == true) {
          tmp.push(this.popData[i].name)
          _ids.push(this.popData[i].id)
        }
      }
      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.Costs.length) {
        _text = this.dic.l["allCosts"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["Costs1"]
        }
      }
      if (_ids.length == 0) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneCost"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }


    if (this.PopupType == 'scheduler') {
      // if (this.popData[0].data[0].checked == true) {
      //   _text = this.dic.l["allvehicles"]
      //   _ids = [0]
      // } else {
      var startIdx = 1
      if (this.OnlyOneVehicle == true) {
        startIdx = 0
      }
      var tmp = []
      for (var i = startIdx; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            tmp.push(this.popData[i].data[j].title)
            _ids.push(this.popData[i].data[j].id)
          }
        }
      }

      if (tmp[0] == 0) {
        tmp.splice(0, 1)
        _ids.splice(0, 1)
      }
      if (tmp.length == this.gn.Vehicles.length) {
        _text = this.dic.l["allvehicles"]
        _ids = [0]
      } else {
        if (tmp.length <= 1) {
          _text = tmp.join(', ')
        } else {
          _text = tmp.length + ' ' + this.dic.l["vehicles"]
        }
      }
      if (_ids.length == 0 && this.moreThanOneVeh == 1) {
        let alert = this.alertCtrl.create({
          title: this.dic.l["moreThanOneVehicle"],
          buttons: [
            {
              text: this.dic.l['ok'],
              handler: data => {
              }
            }
          ]
        });
        alert.present();
      }
      if (_text != '') {
        this.PopupSelectedText = _text
        var cb = this.navParams.get("callback")
        if (cb != null) {
          cb(_text, _ids)
        }
      }

    }

    if (this.PopupType == 'userpopup') {
      _ids = this.PopupSelected
      this.PopupSelectedText = ''
      var cb = this.navParams.get("callback")
      if (cb != null) {
        cb(_text, _ids)
      }
    }

    if (this.PopupType == 'panorama-release') {
      if (this.rvInterval != null) {
        clearInterval(this.rvInterval)
      }
    }
    // if (this.PopupType == 'city' || this.PopupType == 'country') {
    //   _text = this.PopupSelectedText
    //   _ids = this.PopupSelected

    // }

    // console.log('se zatvori')
  }

  splitscreenclick(idx: any) {
    // console.log(idx, 'daj da vidam idx')
    this.nekoja = idx

    // if (idx == 1) {
    //   this.nekoja = '<div> nesto da se slucuva </div>'
    // }

  }
  Change() {
    // document.getElementById("div-hspl").draggable = true
    // document.getElementById("div-hspl").scrollHeight += 10px


    // document.getElementById("change").width = "200";
  }

  dragElement(id: any) {
    // console.log(id, 'elmnt')
    // console.log(id, 'elmnt.id')

    var c = document.getElementById('div-hspl')
    var b = document.getElementById('div-hspl').parentElement
    // console.log(document.getElementById('div-hspl'), 'proba el')
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (document.getElementById('div-hspl')) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById('div-hspl').onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      c.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      // console.log(e, 'prvo e daj mi')
      // e = e || window.event;
      e.preventDefault();
      // console.log(e, 'daj mi e da vidam')
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      // console.log(e, 'e')
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      var maxtop = (c.offsetTop - pos2)
      if (maxtop < 15) {
        maxtop = 15
      }
      console.log(c, 'daj da vidam')

      // set the element's new position:
      c.style.top = maxtop + "px";

      console.log(c.style.top, 'c style top')
      c.style.left = (c.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      // console.log(document, 'coduments')
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }






  chooseVehicles(_id, _ev, _idx, _idx2) {
    // console.log(_id, 'daj da vidime id')

    // console.log('tuka dali vlagas vo chooseVehicles')
    // if (this.firstvehdragfalse == false) {
    //   this.PopupSelected = []
    // }
    var countsmth = 0
    if (this.OnlyOneVehicle == true) {

      this.cntSelected = 0;
      for (var i = 0; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true)
            this.cntSelected++;
        }
      }

      // console.log(this.OnlyOneVehicle, _id, _ev.value)
      if (this.InChooseVehicle == true) { return }
      this.InChooseVehicle = true
      if (_ev._value == true) {
        var tmp = this.popData[_idx].data[_idx2]
        this.popData[0].data.push(tmp)
        this.popData[0].checked = true
        this.popData[_idx].data.splice(_idx2, 1)
      }

      if (_ev._value == false) {
        var tmp = this.popData[_idx].data[_idx2]
        // this.popData[_idx].data.push(tmp)
        for (let kk = 0; kk < this.popData.length; kk++) {
          if (this.popData[_idx].data[_idx2] != undefined) {
            if (this.popData[kk].id == this.popData[_idx].data[_idx2].org) {
              this.popData[kk].data.push(tmp)
              if (this.popData[kk].data == true) {
                this.popData[kk].checked = false
              }
              break
            }
          }
        }
        this.popData[0].data.splice(_idx2, 1)
      }

      // var _that = this
      // setTimeout(function () {
      var temporaryobj
      // var jindex 
      if (this.rec == 1) {
        for (var i = 0; i < this.popData.length; i++) {
          for (var j = 0; j < this.popData[i].data.length; j++) {
            // console.log(this.popData[i].data[j].id, _id)
            //if (this.popData[i].data[j].id + '' != _id + '') {
            // console.log(this.popData[i].data[j].id + '', _id + '', this.cntSelected)

            if (this.popData[i].data[j].id + '' == _id + '' && this.cntSelected > 3) {
              temporaryobj = this.popData[i].data[j]

              this.popData[i].data[j].checked = false
              const toast = this.toastCtrl.create({
                message: this.dic.l["recmax3veh"],
                duration: 3000, position: 'top'
              });
              toast.present();

            }
          }
        }
      } else {
        for (var i = 0; i < this.popData.length; i++) {
          for (var j = 0; j < this.popData[i].data.length; j++) {
            // console.log(this.popData[i].data[j].id, _id)
            if (this.popData[i].data[j].id + '' != _id + '') {
              this.popData[i].data[j].checked = false
              // console.log(this.popData[i].data[j].id)
            } else {
              this.popData[i].data[j].checked = _ev.value
            }
          }
        }
      }

      var _that = this
      setTimeout(function () {
        _that.InChooseVehicle = false

      }, 500)


      setTimeout(() => {
        console.log('ne vleguvas vo time out')
        for (let ii = 0; ii < _that.popData[0].data.length; ii++) {
          console.log(_that.popData[0].data[ii].checked, 'dali se checked da vidime')
          if (_that.popData[0].data[ii].checked == false) {
            console.log('tuka vleguvas vo false')
            for (let kk = 0; kk < _that.popData.length; kk++) {

              console.log(_that.popData[kk].id, ' ====== ', _that.popData[0].data[ii].id, '_that.popData[0].data[ii].id')
              if (_that.popData[kk].id == _that.popData[0].data[ii].org) {
                console.log('dal tuka vleguvas vo if so org id')
                _that.popData[kk].data.push(_that.popData[0].data[ii])
                _that.popData[0].data.splice(ii, 1)
                break
              }
            }
          }
        }

      }, 250);
      // }, 500)
      // debugger



      return
    }
    if (_id == 0) {
      // _selids = [0]
      if (this.popData[1].data.length > 0) {
        for (let kk = 0; kk < this.popData[1].data.length; kk++) {
          for (let pp = 2; pp < this.popData.length; pp++) {
            if (this.popData[1].data[kk].org == this.popData[pp].id) {
              this.popData[pp].data.push(this.popData[1].data[kk])
            }
          }
        }
      }

      this.popData[1].data = []
      var c = this.popData[0].data[0].checked

      for (var i = 2; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          this.popData[i].data[j].checked = c
          this.popData[i].data[j].visible = true
        }
        this.popData[i].checked = c
        this.popData[i].visible = true

      }
    } else {

      if (this.OnlyOneVehicle == false || (this.OnlyOneVehicle == true && this.rec != 1)) {
        if (this.popData[0].data[0].checked == false) {
          for (var i = 2; i < this.popData.length; i++) {
            var cntchkd = 0;
            for (var j = 0; j < this.popData[i].data.length; j++) {
              if (this.firstvehdragfalse == false && countsmth == 0) {
                // debugger
                for (let uu = 0; uu < this.idfirstvehdragfalse.length; uu++) {
                  // debugger
                  if (this.popData[i].data[j].id == this.idfirstvehdragfalse[uu]) {
                    // console.log('vlagas li tuka')
                    // debugger
                    // this.popData[1].data.splice(this.popData[i].data[j], 1)
                  }
                }
              }

              if (this.popData[i].data[j].checked == true) {
                cntchkd++;
                // this.popData[1].data.push(this.popData[i].data[j])

              }
            }
            if (cntchkd == this.popData[i].data.length) {
              this.popData[i].checked = true
            }
          }

          // if (this.isforzero == false) {
          if (_ev._value == true) {
            var tmp = this.popData[_idx].data[_idx2]
            this.popData[1].data.push(tmp)
            this.popData[1].checked = true
            this.popData[_idx].data.splice(_idx2, 1)
          }

          // if (_ev._value == true) {
          //   var tmp = this.popData[_idx].data[_idx2]
          //   this.popData[1].data.push(tmp)
          //   this.popData[_idx].data.splice(_idx2, 1)
          // }  

          if (_ev._value == false) {
            // this.popData[_idx].data.push(tmp)
            for (let kk = 0; kk < this.popData.length; kk++) {
              if (this.popData[_idx] != undefined) {
                if (this.popData[_idx].data[_idx2] != undefined) {
                  var tmp = this.popData[_idx].data[_idx2]
                  if (this.popData[kk].id == this.popData[_idx].data[_idx2].org) {
                    this.popData[kk].checked = false
                    this.popData[kk].data.push(tmp)
                    if (this.popData[kk].data == true) {
                      this.popData[kk].checked = false
                    }
                    break
                  }
                }
              }
            }
            if (this.popData[0].data[0].checked == true) {
              this.popData[0].data[0].checked = false
              this.popData[0].checked = false
            }

            this.popData[1].data.splice(_idx2, 1)

          }

        }

      }




      // }


      // if (this.popData[1].data.length > 0)
      //   for (let oo = 0; oo < this.popData[1].data.length; oo++) {
      //     if (_id == this.popData[1].data[oo].id && _ev._value == false && count == 1) {
      //       debugger
      //       this.popData[1].data.splice(this.popData[1].data[oo], 1)
      //       break
      //     }
      //   }

      // var c = this.popData[1].data

      // var test = c.filter(function (elem, index, self) {
      //   return index === self.indexOf(elem);
      // })


      // this.popData[1].data = test

      countsmth++
      // this.popData[1].data = onlycomp

      // this.popData[0].data[0].checked = false
    }

    for (let uu = 2; uu < this.popData.length; uu++) {
      this.popData[uu].data = this.popData[uu].data.filter((data, index, self) => self.findIndex(t => t.id === data.id) === index)

    }


  }

  chooseConnMech(_id, _ev) {
    if (_id + '' == '0') {
      // _selids = [0]
      var c = this.popData[0].ch
      for (var i = 1; i < this.popData.length; i++) {
        this.popData[i].ch = c
      }
    } else {
      var cntchkd = 0;
      for (var i = 1; i < this.popData.length; i++) {
        if (this.popData[i].ch == true) {
          cntchkd++;
        }
      }
      if (cntchkd == this.popData.length - 1) {
        this.popData[0].ch = true
      }
      // this.popData[0].data[0].checked = false
    }
  }
  chooseCostType(_id, _ev) {
    if (_id + '' == '0') {
      // _selids = [0]
      var c = this.popData[0].ch
      for (var i = 1; i < this.popData.length; i++) {
        this.popData[i].ch = c
      }
    } else {
      var cntchkd = 0;
      for (var i = 1; i < this.popData.length; i++) {
        if (this.popData[i].ch == true) {
          cntchkd++;
        }
      }
      if (cntchkd == this.popData.length - 1) {
        this.popData[0].ch = true
      }
      // this.popData[0].data[0].checked = false
    }
  }

  chooseVehiclesFollow(_id, _ev) {
    if (_id + '' == '-1') {
      // _selids = [0]
      var c = this.popData[0].data[0].checked
      for (var i = 1; i < this.popData.length; i++) {
        for (var j = 0; j < this.popData[i].data.length; j++) {
          this.popData[i].data[j].checked = c
        }
        this.popData[i].checked = c
      }
    } else {
      for (var i = 1; i < this.popData.length; i++) {
        var cntchkd = 0;
        for (var j = 0; j < this.popData[i].data.length; j++) {
          if (this.popData[i].data[j].checked == true) {
            cntchkd++;
          }
        }
        if (cntchkd == this.popData[i].data.length) {
          this.popData[i].checked = true
        }
      }
      // this.popData[0].data[0].checked = false
    }
  }


  selMenu(_idx, _keyPriv) {
    if (this.getPriv(_keyPriv) == false) {
      return false;
    }
    this.PopupSelected = _idx
    this.viewCtrl.dismiss()
  }
  changeRange() {
    if (this.nowHH + '' != this.sliderValue + '') {
      this.todayTraj = false;
    } else {
      this.todayTraj = true;
    }
  }
  changeCheckBox() {
    if (this.todayTraj) {
      this.sliderValue = parseInt(this.nowHH);
    }
  }


  selMenuOther(_id, _text, _priv) {
    if (_priv == false) {
      return false;
    }
    var cb = this.navParams.get("callback")
    if (cb != null) {
      if (this.PopupType === 'vehicles-trajectory') {
        _text = this.sliderValue + ''
        cb(_text, _id, this.todayTraj)
      } else {
        cb(_text, _id)
      }
    }
    this.viewCtrl.dismiss()
  }

  changeLang(_lng) {
    this.dic.changeLanguage(_lng)
    this.viewCtrl.dismiss()
  }
  getPriv(key) {
    if (this.gn.priv.length == 0)
      return true;
    var num;
    for (var i = 0; i < this.gn.priv.length; i++) {
      if (this.gn.user.RoleId == 3) {
        if (this.gn.user.UserId == this.gn.priv[i].userid) {
          return this.gn.priv[i][key];
        }
      } else {
        return true;
      }
    }
  }

  selMenuHelp(_key) {
    // this.PopupSelectedText = _text
    var cb = this.navParams.get("callback")
    if (cb != null) {
      cb(_key)
    }
    this.viewCtrl.dismiss()
  }

  setShift() {
    this.viewCtrl.dismiss()
    let shiftModal = this.modalCtrl.create(SetdrivershiftPage, {}, { cssClass: "modal-fullscreen22" });
    this.selectedModal = 'shift'
    shiftModal.present();
    shiftModal.onDidDismiss(() => {
      this.selectedModal = ''
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/popup/popup.ts